import type { FilterFieldDef } from './types'
import { ProductPicker } from '@/components/products/product-picker'

interface ProductFilterOptions {
    label: () => string
    placeholder?: () => string
}

/**
 * Bộ lọc theo sản phẩm — cùng khuôn với `growerFilter`: giá trị là id, rỗng
 * nghĩa là "tất cả".
 *
 * `parse` chỉ chặn kiểu sai và chuỗi rỗng, không đối chiếu danh sách, vì danh
 * sách sản phẩm nằm ở server và phân trang.
 *
 * KHÔNG tự sinh `chipLabel`: từ id không suy ra được tên sản phẩm. Màn nào cần
 * chip thì tra tên rồi truyền qua `chipLabels` của `useListFilters`.
 */
export function productFilter({
    label,
    placeholder,
}: ProductFilterOptions): FilterFieldDef<string> {
    return {
        defaultValue: '',
        label,
        parse: (raw) => (typeof raw === 'string' && raw ? raw : undefined),
        chipLabel: () => undefined,
        render: ({ id, value, onChange }) => (
            <ProductPicker
                id={id}
                // Trigger của picker là `w-full min-w-0`, nhưng div bọc ngoài
                // của ProductPicker thì không — nằm trong lưới lọc nó phình
                // theo tên sản phẩm và đè sang ô kế bên.
                className="w-full min-w-0"
                value={value}
                onChange={(productId) => onChange(productId)}
                placeholder={placeholder?.()}
                allowClear
            />
        ),
    }
}
